import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PATHS } from "../routes/paths";
import {
  getCidadesAtivasIniciais,
  listCidadesAtivas,
  subscribeCidadeUpdates,
} from "../services/cidades";
import PageHero from "../components/PageHero/PageHero";
import blogFallback from "../assets/images/blog-hero.png";
import "./OndeEstamos.css";

const OndeEstamos = () => {
  const [cidades, setCidades] = useState(getCidadesAtivasIniciais);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    const loadCities = () => {
      setCarregando(true);
      return listCidadesAtivas()
        .then((data) => {
          setCidades(Array.isArray(data) ? data : []);
          setErro(false);
        })
        .catch(() => setErro(false))
        .finally(() => setCarregando(false));
    };

    loadCities();
    return subscribeCidadeUpdates(loadCities);
  }, []);

  return (
    <>
      <PageHero
        imageUrl={blogFallback}
        imageShape="provided"
        title="Onde Estamos"
      />
      <div className="page-shell onde-estamos">
        <div className="page-shell__content">
        <p className="page-shell__description">
          Conheça nossos núcleos regionais.
        </p>

        {carregando && (
          <p className="onde-estamos__estado">Carregando cidades...</p>
        )}

        {!carregando && erro && (
          <p className="onde-estamos__estado onde-estamos__estado--erro">
            Não foi possível carregar a lista de cidades no momento. Tente
            novamente em instantes.
          </p>
        )}

        {!carregando && !erro && cidades.length === 0 && (
          <p className="onde-estamos__estado">
            Nenhuma cidade cadastrada no momento.
          </p>
        )}

        {!carregando && !erro && cidades.length > 0 && (
          <ul className="onde-estamos__lista">
            {cidades.map((cidade) => (
              <li key={cidade.id || cidade.slug} className="onde-estamos__item">
                <Link
                  to={`${PATHS.ondeEstamos}/${cidade.slug}`}
                  className="onde-estamos__link"
                >
                  <span className="onde-estamos__nome">{cidade.name}</span>
                  {cidade.city && (
                    <span className="onde-estamos__cidade">{cidade.city}</span>
                  )}
                </Link>
              </li>
            ))}
          </ul>
        )}
        </div>
      </div>
    </>
  );
};

export default OndeEstamos;
